@let selectedLabel = textToShow(selectedOption());
@let selectedValue = getValue(selectedOption());

<div
  class="bg-blue-primary relative mb-1 flex gap-1 rounded text-white shadow-[0px_1px_3.2px_0px_rgba(0,0,0,0.25)] hover:bg-gray-700">
  <button
    class="flex w-full items-center justify-between px-4 py-2 focus:outline-none"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="isOpen.set(!isOpen())">
    <div class="flex items-center gap-2">
      <ng-content select="[icon]">
        <!-- Se muestra calendar-icon solo si no hay contenido proyectado -->
        <icon name="calendar-icon" />
      </ng-content>
      <span class="font-bold capitalize">{{ selectedLabel }}</span>
    </div>
    <span
      [class.rotate-180]="isOpen()"
      class="text-gray-soft transition-transform">
      <icon name="chevron-up-icon" />
    </span>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  cdkConnectedOverlayWidth="auto"
  (backdropClick)="isOpen.set(false)"
  (detach)="isOpen.set(false)">
  <ul class="select-dropdown">
    @for (option of options(); track option) {
      <li
        class="flex cursor-pointer items-center px-4 py-2 hover:bg-gray-700"
        [appClicks]="labelClick() + ' - ' + option"
        (click)="select(option)">
        <input
          type="radio"
          name="date"
          [checked]="getValue(option) === selectedValue"
          style="width: auto !important; height: auto !important"
          class="size-4 accent-blue-500" />
        <span
          class="ml-3 capitalize"
          [class.font-bold]="getValue(option) === selectedValue"
          [class.text-blue-400]="getValue(option) === selectedValue">
          {{ textToShow(option) }}
        </span>
      </li>
    }
  </ul>
</ng-template>
